<template>
    <div :id="containerId" class="cruise-tag-container list-search-input-tag"
    :class="{ isHighShow: tag.isHighShow}">
        <div :id="tooltipId">
            {{tag.tagType}}
        </div>
        <b-tooltip :target="tooltipId" :container="containerId" triggers="hover" placement="bottom">
            {{tag.tagDescription}}
        </b-tooltip>
    </div>
</template>

<script>
export default {
    name: "CruiseTag",
    props: {
        tag: {
            type: Object,
            default () {
                return {
                    tagType: '',
                    tagDescription: '',
                    isHighShow: false
                }
            }
        },
        index: {
            type: String
        }
    },
    computed: {
        tooltipId () {
            return 'cruiseTag_' + this.index + Math.ceil(Math.random()*1000)
        },
        containerId () {
            return 'container_' + this.tooltipId
        }
    }
}
</script>

<style lang="less" scoped>
.list-search-input-tag {
    padding: 0 20px;
    height: 25px;
    line-height: 25px;
    background-color: #e5f4ff;
    border-radius: 13px;
    color: #0073bb;
    font-size: 12px;
    float: left;
    margin-left: 0px;
    margin-right: 5px;
    margin-top: 7px;
    font-weight: 400;
    cursor: pointer;
}
.list-search-input-tag.isHighShow {
    background-color: #FEBC10;
    color: #fff;
}
</style>

<style lang="less">
.cruise-tag-container {
    .tooltip.in {
        width: auto;
    }
    .tooltip {
        .arrow {
            position: absolute;
            top: 0;
            display: block;
            margin: 0;
            border-color: transparent;
        }
        .arrow:before {
            position: absolute;
            content: "";
            border-color: transparent;
            border-style: solid;
        }
        .tooltip-inner {
            background: #54A3DE;
            color: white;
            padding: 5px 10px;
            max-width: 250px;
        }
    }
    .bs-tooltip-bottom .arrow:before {
        bottom: 0;
        border-width: 0 .4rem .4rem;
        border-bottom-color: #54A3DE;
    }
}
</style>
